<template lang="pug">
	table.table.table-striped.m-0
		thead
			tr
				th Fecha
				th Usuario
				th Titulo
				th Descripción
				th
		tbody
			tr(
				v-for="bitacora in cliente.bitacora"
				:key="bitacora.BitacoraID"
			)
				td {{bitacora.FechaBitacora | moment('DD-MM-YYYY H:mm')}}
				td {{bitacora.UsuarioNombre}}
				td {{bitacora.Titulo}}
				td {{bitacora.Descripcion}}
				td.text-right
					a.btn.btn-sm.btn-primary(v-if="bitacora.URI", :href="'#' + bitacora.URI", target="_blank")
						span.fa.fa-eye
</template>


<script>
export default {
	props: ['cliente']
}
</script>

<style scoped>
thead > tr > th {
	border-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/modulos/gestion-clientes/vue/components/editor/bitacora.vue